var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.group)?_c('transition-group',_vm._g(_vm._b({},'transition-group',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2):_c(_vm.tag,{tag:"component",attrs:{"aria-live":"polite","aria-relevant":"all"}},[_c('transition',_vm._g(_vm._b({},'transition',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }